import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
//import userAuth from "../hooks/UserAuth";
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = () => {
    //const { isAuthenticated, loading } = useAuth();
    const { isAuthenticated, loading } = useAuth();

    if (!isAuthenticated && loading) {
        // Enquanto verifica a sessão, exibe uma tela de carregamento para evitar piscar a tela de login
        return <div className="flex h-screen w-full items-center justify-center"><p>Verificando autenticação...</p></div>;
    }

    // Após a verificação, renderiza o conteúdo protegido se autenticado, senão redireciona para o login
    return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};